"use strict";
exports.__esModule = true;
require("./js/main.js");
require("./css/main.scss");
